import { useAuth } from 'react-oidc-context';

export type { AuthContextProps } from 'react-oidc-context';

/**
 * usePortalAuth — re-exports useAuth from react-oidc-context.
 * Use this hook in portal components instead of importing from react-oidc-context
 * directly, so that the import path is always @nrx/auth-ui.
 */
export { useAuth as usePortalAuth } from 'react-oidc-context';

/**
 * useRoles — extracts Cognito group memberships from the ID token claims.
 * Returns the list of group names (e.g. 'staff:admin', 'staff:wa').
 */
export function useRoles(): string[] {
  const auth = useAuth();
  const groups = auth.user?.profile['cognito:groups'];
  if (!Array.isArray(groups)) return [];
  return groups.filter((g): g is string => typeof g === 'string');
}
